import React from "react";

import { Theme } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import BB8Button from "./BB8Button";

import "./BB8AlertTable.scss";
import BB8SimpleTable from "./BB8SimpleTable";

const issueIdentifier = "error";
const alertCount = "alertCount";

const CustomTableCell = withStyles((theme: Theme) =>
  createStyles({
    body: {
      backgroundColor: "rgb(254, 250, 244)",
      color: "#231F20",
      fontFamily: "Omnes",
      fontSize: 14,
      fontWeight: 500,
      lineHeight: 4,
      opacity: 0.9
    },
    head: {
      alignSelf: "flex-start",
      backgroundColor: "#F2F5F7",
      borderBottomColor: "#CCD9E0",
      borderBottomWidth: 2,
      color: theme.palette.common.black,
      fontWeight: "bold",
      lineHeight: 2,
      position: "sticky",
      top: 0,
      zIndex: 10
    }
  })
)(TableCell);

const styles = (theme: Theme) => ({
  noDataRow: {
    alignItems: "center",
    backgroundColor: (theme.palette as any).status.warning,
    display: "flex"
  },
  root: {
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    width: "100%"
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#F2F5F7"
    },
    borderColor: "#DE7426",
    borderLeftStyle: "solid",
    borderLeftWidth: 4
  },
  table: {
    minWidth: 700
  }
});
interface IBB8AlertTableState {
  expand: { [key: number]: boolean };
}
export interface IBB8AlertTableProps {
  id: string;
  cols: Array<{ id: string; title: string }>;
  data: any;
  classes: any;
  isEmpty: boolean;
  onExpand?: (row: any) => void;
}

class BB8AlertTable extends React.Component<
  IBB8AlertTableProps,
  IBB8AlertTableState
> {
  public state = {
    expand: []
  };

  public render() {
    return (
      <Table id={this.props.id}>
        {!this.props.isEmpty && (
          <TableHead>
            <TableRow>
              {!this.props.isEmpty &&
                this.props.cols.map(({ title }, index: number) => (
                  <CustomTableCell key={index}>{title}</CustomTableCell>
                ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {this.props.isEmpty && (
            <TableRow>
              <CustomTableCell
                className={this.props.classes.noDataRow + " no-data-row"}
                colSpan={this.props.cols.length}
              >
                <div className="no-data-row-icon" />
                <div className="no-data-row-message">
                  {/* TODO: pass message in as props  */}
                  No unresolved file failures
                </div>
              </CustomTableCell>
            </TableRow>
          )}
          {this.props.data.map((row: any, i: number) => {
            return (
              <React.Fragment key={i}>
                <TableRow
                  hover={true}
                  key={i}
                  className={this.props.classes.row}
                >
                  {this.props.cols.map(({ id }) => (
                    <CustomTableCell key={`cell-${id}-${i}`}>
                      {id !== "issues"
                        ? row[id]
                        : row[issueIdentifier].data && (
                            <BB8Button
                              variant="text"
                              // tslint:disable-next-line:jsx-no-lambda
                              onClick={() => this.toggleRow(i, row)}
                            >
                              {row[alertCount]}
                              <img
                                src={require("../assets/images/bb8-expand_more-24px.svg")}
                                style={
                                  this.state.expand[i]
                                    ? { transform: "rotate(180deg)" }
                                    : undefined
                                }
                              />
                            </BB8Button>
                          )}
                    </CustomTableCell>
                  ))}
                </TableRow>
                {this.state.expand[i] && (
                  <TableRow hover={true} key={`row-${i}`}>
                    <TableCell>{}</TableCell>
                    <TableCell colSpan={6}>
                      {row[issueIdentifier].data ? (
                        <BB8SimpleTable
                          key={`sub-table-${i}`}
                          cols={row[issueIdentifier].cols}
                          data={row[issueIdentifier].data}
                        />
                      ) : null}
                    </TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    );
  }
  private toggleRow = (i: number, row: any) => {
    this.setState(currentState => ({
      expand: { ...currentState.expand, [i]: !currentState.expand[i] }
    }));
    if (this.props.onExpand) {
      this.props.onExpand(row);
    }
  };
}

export default withStyles(styles as any)(BB8AlertTable);
